import { render, staticRenderFns } from "./Info_mobile.vue?vue&type=template&id=550867d6&scoped=true&"
import script from "./Info_mobile.vue?vue&type=script&lang=js&"
export * from "./Info_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Info_mobile.vue?vue&type=style&index=0&id=550867d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550867d6",
  null
  
)

export default component.exports